import { ValidFormItem } from '../types'

export const regExpOnlyLatin = (value: string) => !/^[a-zA-Z\s.,-_]+$/.test(value)

export const getRequiredError = (value: string): ValidFormItem[] => {
  return [{ invalid: value?.trim?.().length === 0, error: 'Поле не может быть пустым' }]
}

export const getOnlyLatinCharError = (value: string): ValidFormItem[] => {
  return [{ invalid: regExpOnlyLatin(value), error: 'Поле должно быть указано на латинице' }]
}
